import brand1Image from '../images/jj.svg';
import brand2Image from '../images/alcon.svg';
import brand3Image from '../images/zeiss.svg';
import brand4Image from '../images/bl.svg';
import brand5Image from '../images/GEHC-120f4dff.png';
import brand6Image from '../images/Breas_Logo_Banner_01_57109f94dd.png';
import brand7Image from '../images/ResMed_logo.svg';
import brand8Image from '../images/sysmed_logo.png';
import brand9Image from '../images/philps-healthcare.png';

const brandData = [
  [
    { src: brand1Image, alt: 'Brand 1' },
    { src: brand2Image, alt: 'Brand 2' },
    { src: brand3Image, alt: 'Brand 3' },
  ],
  [
    { src: brand4Image, alt: 'Brand 4' },
    { src: brand5Image, alt: 'Brand 5' },
    { src: brand6Image, alt: 'Brand 6' },
  ],
  [
    { src: brand7Image, alt: 'Brand 7' },
    { src: brand8Image, alt: 'Brand 8' },
    { src: brand9Image, alt: 'Brand 9' },
  ],
];

export default brandData;